export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_23-0c873189c2dbb9e65edb3d5c43a3aeeb.jpg";